// imports here
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";
import { useNavigate } from "react-router-dom";

export const backRoute = "/map/puertorico";

// ⭐ FIX #1 — Accept the section prop
export default function RinAguAsco({ section }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Your existing effect (keep it)
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  // ⭐ FIX #2 — Add scroll effect RIGHT HERE
  useEffect(() => {
    if (section) {
      setTimeout(() => {
        const el = document.getElementById(section);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 250);
    }
  }, [section]);

  // ⭐ AFTER BOTH EFFECTS → your return starts
  return (
    <>
      <Header />
      <div className="visited-back-wrapper">
        <BackOnly />
      </div>



      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Rincón / Aguada /Añasco</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            

<div id="rincon">
  <h3>🏰 Rincón</h3>

  <p>
    Rincón is one of Puerto Rico's most iconic beach towns, famous for its 
    world-class surfing, relaxed atmosphere, and unforgettable sunsets. 
    Popular beaches include Domes Beach, Sandy Beach, and Steps Beach, each 
    offering great waves, snorkeling spots, and scenic views.
  </p>

 <p>
  The town has a charming coastal vibe with local shops, restaurants, and 
  beach bars. Three of my personal favorite spots are Tamboo Rincón — a great 
  place with ocean views, a covered restaurant area, and a rooftop terrace 
  perfect for drinks, plus the food is very good. The second place is 
  Hotel Villa Cofresí, which I love for its great food and drinks; their 
  specialty, <em> El Pirata</em>, is served in a coconut. The food here is 
  also excellent, but note that it is not pet friendly. The last one is the 
  Rincón Lighthouse (El Faro), another perfect spot to enjoy ocean views and 
  watch the sunset.
</p>


  {/* ⭐ MAP LINKS BLOCK — CLEAN & ALIGNED */}
  <div style={{ marginTop: "8px", marginBottom: "16px", lineHeight: "1.8" }}>
    <a
      href="https://www.google.com/maps?q=18.36217055162483,-67.27099869516954"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Rincón Lighthouse
    </a>
    <br />

    <a
      href="https://www.google.com/maps?q=18.370223749348817,-67.25765435358514"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Tamboo Rincón
    </a>
    <br />

    <a
      href="https://www.google.com/maps?q=18.328354874309277,-67.25060194818631"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Hotel Villa Cofresí
    </a>
  </div>

  <p>Rincón also hosts several annual events, including:</p>

  <ul>
    <li>
      <strong>Fiestas Patronales de Rincón</strong> — Celebrated in honor of 
      <em>Santa Rosa de Lima</em>, usually in <strong>August</strong>. 
      Includes live music, artisans, food kiosks, parades, and cultural 
      activities in the town plaza.
    </li>

    <li>
      <strong>Rincón Surfing Festival</strong> — A major surfing competition 
      that attracts local and international surfers during the winter swell 
      season (November–February).
    </li>

  </ul>

  <p>
    Whether you're exploring beaches, enjoying local food, or chasing sunsets, 
    Rincón delivers some of the most memorable coastal experiences in Puerto Rico.
  </p>
</div>


<p>
  In this Section I will be talking about 3 towns in Puerto Rico, Rincó, Aguada and Añasco.  
  These towns are located on the west coast of Puerto Rico and are known for their beautiful 
  beaches and because they are close to each other I is easy to visit all three in one trip.</p> 






<div id="aguada">
  <h3>🌊 Aguada</h3>

  <p>
    Aguada is a peaceful coastal town on Puerto Rico’s west coast, known for 
    its relaxed atmosphere, friendly locals, and beautiful beaches. It’s a 
    great place to slow down, enjoy the ocean, and explore the natural beauty 
    of the region. One of the highlights is the scenic coastal drive from 
    Aguadilla to Aguada — a stretch filled with ocean views, palm trees, and 
    small beach spots perfect for photos or quick stops.
  </p>

  <p>
    One of the most popular beaches in Aguada is <strong>Parque Colón Beach</strong>, 
    a family‑friendly spot with calm waters, picnic areas, and a wide sandy 
    shoreline. It’s perfect for swimming, relaxing, or enjoying a quiet day 
    by the ocean. Another great place to explore is the <strong>Aguada Tree House</strong>, 
    a unique wooden structure surrounded by nature — a fun stop for photos 
    and a peaceful place to enjoy the outdoors.
  </p>

  {/* ⭐ MAP LINKS BLOCK — CLEAN & ALIGNED */}
  <div style={{ marginTop: "8px", marginBottom: "16px", lineHeight: "1.8" }}>
    <a
      href="https://www.google.com/maps?q=18.413176473618027,-67.1618274586603"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Aguada Tree House
    </a>
    <br />

    <a
      href="https://www.google.com/maps?q=18.415314167095243, -67.16013230257319"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Parque Colón Beach
    </a>
    <br />

    <a
      href="https://www.google.com/maps?q=18.39294662411897, -67.19372869078249"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Coastal Drive (Aguadilla → Aguada)
    </a>
  </div>

  <p>Aguada also celebrates several cultural events throughout the year:</p>

  <ul>
    <li>
      <strong>Fiestas Patronales de San Francisco de Asís</strong> — Held in 
      <strong>October</strong>, featuring live music, artisans, food kiosks, 
      rides, and cultural activities in the town plaza.
    </li>

    <li>
      <strong>Festival del Descubrimiento</strong> — A celebration related to 
      the town’s historical connection to early Spanish arrival, with parades, 
      performances, and community events.
    </li>

    <li>
      <strong>Summer Beach Events</strong> — Local beach gatherings, food 
      festivals, and small concerts often take place along the coast during 
      the summer months.
    </li>
  </ul>

  <p>
    Aguada is perfect for travelers who enjoy quiet beaches, scenic drives, 
    and authentic local culture. Whether you're exploring Parque Colón, 
    visiting the Tree House, or enjoying the coastal views, Aguada offers a 
    peaceful and memorable west‑coast experience.
  </p>
</div>






<div id="anasco">
  <h3>🌴 Añasco</h3>

  <p>
    Añasco is a peaceful coastal town on Puerto Rico’s west coast, known for 
    its rivers, beaches, and relaxed countryside atmosphere. It’s a great 
    place to enjoy quiet coastal views, explore local food spots, and take in 
    the natural beauty of the region. The town sits between Rincón and Mayagüez, 
    making it a convenient stop for travelers exploring the west.
  </p>

  <p>
    One of the most popular areas in Añasco is the <strong>Balneario de Añasco</strong>, 
    a long stretch of beach with calm waters, picnic areas, and plenty of shade. 
    It’s perfect for families, swimming, or simply relaxing by the ocean. 
    Añasco is also known for its rivers and bridges, including scenic spots 
    along the Río Grande de Añasco, which flows through the town and into the coast.
  </p>

  {/* ⭐ MAP LINKS BLOCK — CLEAN & ALIGNED */}
  <div style={{ marginTop: "8px", marginBottom: "16px", lineHeight: "1.8" }}>
    <a
      href="https://www.google.com/maps?q=Balneario+de+Anasco"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Balneario de Añasco
    </a>
    <br />

    <a
      href="https://www.google.com/maps?q=R%C3%ADo+Grande+de+Anasco"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Río Grande de Añasco
    </a>
    <br />

    <a
      href="https://www.google.com/maps?q=Anasco+Town+Plaza"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Añasco Town Plaza
    </a>
  </div>

  <p>Añasco celebrates several cultural events throughout the year:</p>

  <ul>
    <li>
      <strong>Fiestas Patronales de San Antonio Abad</strong> — Held in 
      <strong>January</strong>, featuring live music, artisans, food kiosks, 
      rides, and cultural activities in the town plaza.
    </li>

    <li>
      <strong>Festival del Arroz con Dulce</strong> — A unique local festival 
      celebrating one of Puerto Rico’s traditional desserts, with food, music, 
      and community activities.
    </li>

    <li>
      <strong>Summer Beach Events</strong> — Small concerts, food stands, and 
      family activities often take place along the Añasco coastline during the 
      summer months.
    </li>
  </ul>

  <p>
    Añasco is perfect for travelers who enjoy quiet beaches, local traditions, 
    and scenic nature spots. Whether you're relaxing at the Balneario, exploring 
    the Río Grande, or enjoying the town’s cultural events, Añasco offers a calm 
    and authentic west‑coast experience.
  </p>
</div>






 <h3>🚗 Getting There</h3>

<p>
  Reaching Rincón, Aguada, and Añasco is easy whether you're arriving through 
  <strong> San Juan (SJU)</strong> or <strong>Aguadilla (BQN)</strong>. Both airports connect 
  directly to Puerto Rico’s west coast via well‑maintained highways.
</p>

<p>
  <strong>From San Juan (SJU):</strong> The drive to the west coast takes about 
  <strong> 2.5 to 3 hours</strong>. The fastest route is taking <strong> PR‑22</strong> westbound 
  toward Arecibo and continuing until the expressway ends. From there, follow 
  <strong> PR‑2</strong> through Aguadilla and into Aguada, Añasco, or Rincón. This is a smooth, 
  scenic highway drive with plenty of gas stations, rest stops, and food options along the way.
</p>

<p>
  <strong>From Aguadilla (BQN):</strong> This is the closest airport to all three towns. 
  Driving from BQN takes only <strong>20–30 minutes</strong> depending on your destination. 
  Simply follow <strong>PR‑107</strong> or <strong>PR‑2</strong> south toward Aguada and Añasco, or 
  north toward Rincón. This route is very straightforward and ideal for travelers who want to 
  reach the west coast quickly.
</p>

<p>
  Whether you're coming from SJU or BQN, the roads are easy to navigate, and the west coast 
  rewards you with ocean views, local food spots, and some of the most beautiful beaches in 
  Puerto Rico.
</p>



           


           <h3>🛏️ Places to Stay in Rincón / Aguada / Añasco</h3>

<p>
  These west‑coast towns offer a mix of beachfront hotels, boutique stays, and 
  local guesthouses. All the properties listed below are available on 
  <strong>Expedia</strong> (priority) and <strong>Booking.com</strong>.  
  Always double‑check availability and reviews before booking.
</p>

<ul>

  {/* ⭐ RINCÓN HOTELS */}
  <li>
    <div className="place-block">
      <strong>Villa Cofresí (Rincón):</strong>
      Beachfront hotel famous for its sunset views and the signature drink 
      <em> El Pirata</em> served in a coconut.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Rincon Beach Resort (Añasco/Rincón border):</strong>
      A beautiful beachfront resort with a large pool, restaurant, and direct 
      access to calm waters — perfect for families.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Casa Verde Hotel (Rincón):</strong>
      Popular boutique hotel near Sandy Beach with a relaxed surf‑town vibe.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  {/* ⭐ AGUADA HOTELS */}
  <li>
    <div className="place-block">
      <strong>Hotel Colombus (Aguada):</strong>
      Oceanfront hotel with a pool, restaurant, and great views — located 
      right along the Aguada coastline.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hidden Beach Resort (Aguada):</strong>
      A quiet, adults‑only style stay with beachfront access and a peaceful 
      atmosphere.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  {/* ⭐ AÑASCO HOTELS */}
  <li>
    <div className="place-block">
      <strong>Yukayeke Playa Resort (Añasco):</strong>
      Beachfront cabins and rooms with a tropical, rustic feel — great for 
      families and groups.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Rincon Beach Resort (Añasco):</strong>
      Technically located in Añasco but often associated with Rincón — one of 
      the best beachfront resorts on the west coast.
      <br />
      <em>Available on Expedia & Booking.com</em>
    </div>
  </li>

</ul>



            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
             Here are some of my travel videos for Rincón, Aguada and Añasco. 
            
            </p>

            <p>
              <a
                href="https://youtu.be/Ockxzelm3oE?si=emLId6MizRnAcinB"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rincón Lighthouse
              </a>
            </p>
             <p>
              <a
                href="https://youtu.be/Tu-MOXBZciY?si=Cc7bF0KGTJpK4Dd6"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aguada Tree House
              </a>
            </p>
             <p>
              <a
                href="https://youtu.be/78ftgGG_wsU?si=riZjczGCd2dobin9"
                target="_blank"
                rel="noopener noreferrer"
              >
                The Drive to Rincón
              </a>
            </p>


          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/Ockxzelm3oE?si=2fFPzeEielS86Ny9"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                 src="/images/usa/puertorico/rincon/faro1.jpg"
              alt="Rincón Lighthouse"
              />
            </a>

           
            <img
              src="/images/usa/puertorico/rincon/domo.jpg"
              alt="Rincón dome beach"
            />
            <img
              src="/images/usa/puertorico/rincon/domo2.jpg"
              alt="Rincón dome beach"
            />
            <img
              src="/images/usa/puertorico/rincon/hvc.jpg"
              alt="Rincón Hotel Villa Cofresí"
            />
             <img
              src="/images/usa/puertorico/rincon/hvc2.jpg"
              alt="Rincón Hotel Villa Cofresí"
            />
             <img
              src="/images/usa/puertorico/rincon/playa3.jpg"
              alt="Beach"
            />
            <a
              href="https://youtu.be/78ftgGG_wsU?si=hercCTgDOnWl7Kdd"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                 src="/images/usa/puertorico/rincon/playa2.jpg"
              alt="Drive to Rincón"
              />
            </a>

             <a
              href="https://youtu.be/Tu-MOXBZciY?si=TzgmCpiTDWPICZSH"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                 src="/images/usa/puertorico/rincon/cda.jpg"
              alt="Tree House"
              />
            </a>
             
              <img
              src="/images/usa/puertorico/rincon/cda2.jpg"
              alt="Plaza"
            />
            <img
              src="/images/usa/puertorico/rincon/plaza1.jpg"
              alt="Plaza"
            />
             <img
              src="/images/usa/puertorico/rincon/plaza2.jpg"
              alt="Plaza"
            />
             <img
              src="/images/usa/puertorico/rincon/plaza3.jpg"
              alt="Plaza"
            />

             <img
              src="/images/usa/puertorico/rincon/plaza4.jpg"
              alt="Plaza"
            />
           <img
              src="/images/usa/puertorico/rincon/tamboo.jpg"
              alt=" Tamboo Rincón"
            />


          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
